import { render, staticRenderFns } from "./topUp.vue?vue&type=template&id=bf3bfcb4&scoped=true&"
import script from "./topUp.vue?vue&type=script&lang=js&"
export * from "./topUp.vue?vue&type=script&lang=js&"
import style0 from "./topUp.vue?vue&type=style&index=0&id=bf3bfcb4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf3bfcb4",
  null
  
)

export default component.exports